export const CREATE_USER_ITEMS = [
  {
    id: "name",
    type: "text",
    apiKey: "name",
    label: "USER_MANAGEMENT.LIST.NAME",
    render: function (t, showAddUserModal, userData, handleChange, userError) {
      return render(
        this,
        showAddUserModal,
        userData,
        t,
        handleChange,
        userError
      );
    },
    regex: /^[a-zA-Z\s]{2,50}$/,
    isDisabled: function (showAddUserModal) {
      return isItemDisabled(showAddUserModal, this);
    },
    validationError: "Invalid Name",
  },
  {
    id: "email",
    type: "text",
    apiKey: "email",
    label: "USER_MANAGEMENT.LIST.EMAIL",
    render: function (t, showAddUserModal, userData, handleChange, userError) {
      return render(
        this,
        showAddUserModal,
        userData,
        t,
        handleChange,
        userError
      );
    },
    regex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    isDisabled: function (showAddUserModal) {
      return isItemDisabled(showAddUserModal, this);
    },
    validationError: "Invalid Email",
  },
  {
    id: "mobile",
    type: "text",
    apiKey: "mobile",
    label: "USER_MANAGEMENT.LIST.MOBILE",
    render: function (t, showAddUserModal, userData, handleChange, userError) {
      return render(
        this,
        showAddUserModal,
        userData,
        t,
        handleChange,
        userError
      );
    },
    regex: /^[0-9]{8,12}$/,
    isDisabled: function (showAddUserModal) {
      return isItemDisabled(showAddUserModal, this);
    },
    validationError: "Mobile number must be of 8-12 length",
  },
];

function isItemDisabled(showAddUserModal, item) {
  if (typeof showAddUserModal === "boolean") {
    return false;
  }
  if (["email"].includes(item.id)) {
    return true;
  }
  return false;
}

function render(
  item,
  showAddUserModal,
  userData,
  t,
  handleChange,
  userError = {}
) {
  switch (item.type) {
    case "text":
      return (
        <fieldset key={item.id} className="form-filed col-md-12">
          <div className={`material ${userError[item.apiKey] ? "error" : ""}`}>
            <input
              type="text"
              placeholder=""
              value={userData[item.apiKey] || null}
              onChange={(e) => handleChange(item.apiKey, e.target.value)}
              name={item.id}
              className="form-input"
              disabled={item.isDisabled(showAddUserModal)}
            />
            <label
              data-label={`${t(item.label)}${
                typeof showAddUserModal === "boolean" ? "*" : ""
              }`}
              className="form-label"
            ></label>
            {userError[item.apiKey] ? (
              <span className="erroe-txt">{userError[item.apiKey]}</span>
            ) : null}
          </div>
        </fieldset>
      );

    default:
      return null;
  }
}
